import React, { useContext, useEffect, useState, Suspense } from 'react';
import PropTypes from 'prop-types';
import {
    singleTopicPropTypes,
    singleCommentPropTypes,
} from '../../defaultProps';
import Layout from '../../../components/Layout/LayoutV2/Layout';
import { PageContext } from '../../../contexts/ContextCreator';
import { Provider as CommunityContextProvider } from '../../../contexts/CommunityContext';
import './DiscussionPage.scss';
import { CommunityPostDisplayPage } from '../../../components/Community/SingleContent/CommunityPostDisplay/CommunityPostDisplayPage';
import { CommunityContentProvider } from '../../../components/Community/SingleContent/CommunityPostDisplay/CommunityPostContentContext';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

const GoogleOneTap = React.lazy(() =>
    import('../../../components/Login/GoogleOneTap/GoogleOneTap')
);

const DiscussionPage = (props) => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);

    const { content, recentContent } = props;
    const { isLoggedIn, pageProps } = useContext(PageContext);

    const showGoogleoneTapLogin = () => {
        return (
            typeof window !== 'undefined' &&
            (process.env.NODE_ENV !== 'local' ||
                window?.document?.referrer.includes('google')) &&
            !isLoggedIn()
        );
    };

    const constructCommunityContentkey = () =>
        `${props.content.type}-${props.content.hash}`;

    return (
        <CommunityContextProvider
            singleAttributionContentHash={props.content.hash}
            attributionMode="single"
            content={[content]}
            topics={props?.topics}
        >
            <SnowplowPageViewTracker
                pageEntityId={constructCommunityContentkey()}
                pageSection={PAGE_VIEW_SECTIONS.COMMUNITY}
                pageType={PAGE_VIEW_TYPES.CONTENT}
            />
            <div
                className="discussion-page"
                itemID={`https://fairygodboss.com${props.content.contentUrl}`}
                itemScope
                itemType="https://schema.org/DiscussionForumPosting"
            >
                <meta
                    itemProp="url"
                    content={`https://fairygodboss.com${props.content.contentUrl}`}
                />
                {isMounted && showGoogleoneTapLogin() && (
                    <Suspense fallback={null}>
                        <GoogleOneTap gclientId={pageProps.googleClientId} />
                    </Suspense>
                )}
                <Layout
                    {...props}
                    topBannerOnlyShownList={['admin-onboard']}
                    className={props.group?.groupUrl ? 'groups-layout' : ''}
                >
                    <CommunityContentProvider
                        content={content}
                        recentContent={recentContent}
                    >
                        <CommunityPostDisplayPage />
                    </CommunityContentProvider>
                </Layout>
            </div>
            )
        </CommunityContextProvider>
    );
};

DiscussionPage.propTypes = {
    PAGE_PROPS: PropTypes.shape({ featureFlags: PropTypes.shape({}) }),
    adminOnboardingProps: PropTypes.shape({}),
    /**
     * Content props
     */
    recentContent: PropTypes.arrayOf(singleCommentPropTypes),
    content: singleCommentPropTypes.isRequired,
    ancestorHash: PropTypes.string,
    /**
     * This is used in Three Column Grid Layout
     */
    topics: PropTypes.arrayOf(singleTopicPropTypes).isRequired,
    /**
     * Boolean as to hide reaction bar for the Editorial/Podcast Content
     */
    // This is a known es-lint bug where if it's a prop that's just passed, it's not considered used...
    /* eslint-disable-next-line  react/no-unused-prop-types */
    hideReactionBar: PropTypes.bool,
    group: PropTypes.shape({
        groupUrl: PropTypes.string,
    }),
    location: PropTypes.string,
    userRelation: PropTypes.shape({}),
};

DiscussionPage.defaultProps = {
    PAGE_PROPS: {},
    recentContent: null,
    adminOnboardingProps: {},
    hideReactionBar: false,
    group: null,
    location: null,
    userRelation: null,
    ancestorHash: null,
};

export default DiscussionPage;
